module.exports = __webpack_public_path__ + "static/media/bidenable.f9f86445.svg";